import { LayoutTemplate, Newspaper } from 'lucide-react'
import { SeoConfigTable, type SeoField } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

const STATUS_FIELD: SeoField = {
  name: 'status',
  placeholder: S.status,
  options: [
    { value: 'draft', label: S.draft },
    { value: 'published', label: S.published },
  ],
}

/**
 * A12.22 — Landing sahifalar konstruktori. Landing sahifalar reyestri (slug +
 * sarlavha + holat). CRUD `/admin/seo/landing` (fail-soft).
 */
export function LandingPagesScreen() {
  return (
    <SeoConfigTable
      screenId="A12.22"
      title={S.landing}
      addLabel={S.addLanding}
      path="/admin/seo/landing"
      listKey="pages"
      searchKeys={['slug', 'title']}
      icon={<LayoutTemplate size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'slug', placeholder: 'promo-2026', mono: true },
        { name: 'title', placeholder: S.titleCol },
        STATUS_FIELD,
      ]}
      columns={[
        { key: 'slug', header: S.slug, type: 'text' },
        { key: 'title', header: S.titleCol, type: 'text' },
        { key: 'status', header: S.status, type: 'text' },
      ]}
    />
  )
}

/**
 * A12.23 — Blog / yangiliklar CMS. Blog yozuvlari reyestri (slug + sarlavha +
 * holat). CRUD `/admin/seo/blog` (fail-soft).
 */
export function BlogCmsScreen() {
  return (
    <SeoConfigTable
      screenId="A12.23"
      title={S.blog}
      addLabel={S.addBlog}
      path="/admin/seo/blog"
      listKey="posts"
      searchKeys={['slug', 'title']}
      icon={<Newspaper size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'slug', placeholder: 'my-post', mono: true },
        { name: 'title', placeholder: S.titleCol },
        STATUS_FIELD,
      ]}
      columns={[
        { key: 'slug', header: S.slug, type: 'text' },
        { key: 'title', header: S.titleCol, type: 'text' },
        { key: 'status', header: S.status, type: 'text' },
      ]}
    />
  )
}
